import axiosClient from "../../../config/axios";

const sendReportConsent = async (xlsx, emails) => {
  try{
    const formData = new FormData();
    formData.append('file', xlsx);

    emails.forEach(email => {
      formData.append('emails[]', email);
    });

    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const response = await axiosClient.post('/medical-documents/reports/consent', formData, {headers});
    return response;
  }catch (error) {
    return error;
  }
}

const sendOmAndLetter = async (xlsx, emails) => {
  try{
    const formData = new FormData();
    formData.append('file', xlsx);
    formData.append('adminId', '6446e10e51d548dbb231533d');
    
    emails.forEach(email => {
      formData.append('emails[]', email);
    });

    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const response = await axiosClient.post('/medical-documents/batch', formData, {headers});
    return response;
  }
  catch (error) {
    return error;
  }
}

export {
  sendReportConsent,
  sendOmAndLetter
}